import React, { useEffect,  useState } from 'react'
import fb from "../Assets/Social/fb.png";
import tg from "../Assets/Social/tg.png";
import tk from "../Assets/Social/tk.png";
import yt from "../Assets/Social/yt.png";
import ig from "../Assets/Social/ig.png";



import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { MapLink } from './Url';
const containerStyle = {
  width: '400px',
  height: '400px'
};
function Footer(props) {
  const ref =useRef(null);
  const isView =useInView(ref,{margin:'-20% 0px -20% 0px'});

 const data={
  data: [
    { icon: fb,link:props?.social?.facebookLink },
     { icon: tg,link:props?.social?.telegramLink  }, 
     { icon: tk,link:props?.social?.tiktokLink },
      { icon: yt,link:props?.social?.youtubeLink }, 
      { icon: ig,link:props?.social?.instagramLink }
    ],
 }

function call(record){
  window.location.href = `tel:${record}`;
} 
// const { isLoaded } = useJsApiLoader({
//   id: 'google-map-script',
//   googleMapsApiKey: MapLink
// })

const center = {
  lat: props?.lat,
  lng: props?.long
};
// const [map, setMap] = React.useState(null)

  // const onLoad = React.useCallback(function callback(map) {
  //   // This is just an example of getting and using the map instance!!! don't just blindly copy!
  //   const bounds = new window.google.maps.LatLngBounds(center);
  //   map.fitBounds(bounds);

  //   setMap(map)
  // }, [])

  // const onUnmount = React.useCallback(function callback(map) {
  //   setMap(null)
  // }, [])

  const checkAndAddHttps=(link)=>{
    const hasHttps=link.startsWith("https://");
    return hasHttps?link:"https://"+link;
   }
   const iframeRef = useRef();

   const getSrc = () => {
  // Get the first iframe element.
// const iframe = document?.querySelector('iframe');
// if(iframe){
//   // Set the ref attribute of the iframe element to the variable.
//   iframe.ref = ref;
// }

// // Get the src attribute of the iframe element using the ref.
// const src = iframeRef?.current?.src;
const iframe = document.querySelector('iframe');

// Add the ref and className attributes.
iframe?.setAttribute('ref', 'iframeRef');
iframe?.setAttribute('className', 'hidden');

// Remove the width and height attributes.
iframe?.removeAttribute('width');
iframe?.removeAttribute('height');

// Update the final HTML code.
const newHtml = iframe?.outerHTML;

// Display the final HTML code.

    return newHtml;
  };
  const [link,setLink]=useState('')
  useEffect(()=>{
setLink(getSrc)
  },[getSrc])
  return (
  <div ref={ref} className='bg-[#1D001C] text-white  '>
  
    <div  className='w-full '>
      <div className='flex flex-col gap-4  md:flex-row px-[5vw] md:px-0 lg:px-0 md:w-[95%] lg:w-[98%] lg:mx-[2%]  md:justify-between mb-[29px] lg:mb-0 '>
<div className='flex mt-5 items-start md:items-center lg:gap-[103px]  gap-5 md:gap-4 lg:ml-0 md:ml-[5%]'>
<div className='flex flex-col gap-4 justify-center lg:mt-[-40px] xl:mt-[-40px] '>
  <p className='text-[15px] md:text-[18px] lg:text-[24px] text-start Poppins leading-[36px] Popp-600  '>Get In Touch</p>
  <div className={` ${isView?'translation-all duration-500 scale-500 flex gap-4':'scale-0'} 'flex gap-4'`}>
  <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M8.175 6.25C8.25 7.3625 8.4375 8.45 8.7375 9.4875L7.2375 10.9875C6.725 9.4875 6.4 7.9 6.2875 6.25H8.175ZM20.5 21.275C21.5625 21.575 22.65 21.7625 23.75 21.8375V23.7C22.1 23.5875 20.5125 23.2625 19 22.7625L20.5 21.275ZM9.375 3.75H5C4.3125 3.75 3.75 4.3125 3.75 5C3.75 16.7375 13.2625 26.25 25 26.25C25.6875 26.25 26.25 25.6875 26.25 25V20.6375C26.25 19.95 25.6875 19.3875 25 19.3875C23.45 19.3875 21.9375 19.1375 20.5375 18.675C20.4125 18.625 20.275 18.6125 20.15 18.6125C19.825 18.6125 19.5125 18.7375 19.2625 18.975L16.5125 21.725C12.975 19.9125 10.075 17.025 8.275 13.4875L11.025 10.7375C11.375 10.3875 11.475 9.9 11.3375 9.4625C10.875 8.0625 10.625 6.5625 10.625 5C10.625 4.3125 10.0625 3.75 9.375 3.75Z" fill="white"/>
</svg>
<p onClick={()=>call(props.props?.phone)}  className={`${isView?'translation-all duration-500 scale-500':'scale-0'} text-[10px] md:text-[14px] cursor-pointer lg:text-[20px] leading-[24px] Poppins Popp-400 `}>
{props.props?.phone}   
</p>
  </div>
  <div className={` ${isView?'translation-all duration-500 scale-500 flex gap-4':'scale-0'} flex gap-4`}>
  <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M27.5 7.5C27.5 6.125 26.375 5 25 5H5C3.625 5 2.5 6.125 2.5 7.5V22.5C2.5 23.875 3.625 25 5 25H25C26.375 25 27.5 23.875 27.5 22.5V7.5ZM25 7.5L15 13.75L5 7.5H25ZM25 22.5H5V10L15 16.25L25 10V22.5Z" fill="white"/>
</svg>

<p className='text-[10px] md:text-[14px] lg:text-[20px] leading-[24px] Poppins Popp-400 '>
{props.props?.email}
</p>
  </div>
</div>
{/* Quick Link */}
<div className={` ${isView?'translation-all duration-500 scale-500 flex flex-col gap-4 justify-center':'scale-0'} 'flex flex-col gap-4 justify-center'`}>
  <p className='text-[15px] md:text-[18px] lg:text-[24px] text-start Poppins leading-[36px] Popp-600'>Quick Links</p>
  <div className='flex '>

<a href="https://www.gcmethiopia.org" target="_blank" className='text-[10px] md:text-[14px] lg:text-[20px] md:leading-[24px] Poppins Popp-400 '>
Great Commission Ministry
</a>
  </div>
  <div className='flex '>
<a href="https://www.evasue.net " target="_blank" className='text-[10px] md:text-[14px] lg:text-[20px] md:leading-[24px] Poppins Popp-400 '>
EvaSUE
</a>
  </div>
  <div className='flex '>


<a href="https://www.focusministry.org/" target="_blank" className='text-[10px] md:text-[14px] lg:text-[20px] md:leading-[24px] Poppins Popp-400 '>
FOCUS Ethiopia
</a>
  </div>
</div>

</div>

<div className={`${isView?'translation-all duration-700 scale-500 mt-[47px]':'scale-0'} lg:mr-[2%] mt-[47px] lg:mt-[34px] lg:mb-[42px]`}>
{/* <iframe src={props.props.mapLink} className='w-full h-[177px] lg:h-[344px] lg:w-[679px] md:w-[360px] md:h-[250px] rounded-[10px]'  style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"/> */}
{!props?.mapSrc? <div>Loading...</div>:
 <div className='w-full h-[177px] lg:h-[344px] lg:w-[579px] md:w-[360px] md:h-[250px] rounded-[10px] flex items-center'>
   {/* <iframe
      className="hidden"  
       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1195.485283384842!2d38.814981600690224!3d9.019564668177447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8551efe7ecd1%3A0xab9a688df4ee4751!2zMlI5NytNUkcsIOGKoOGLsuGItSDhiqDhiaDhiaM!5e1!3m2!1sam!2set!4v1696503811355!5m2!1sam!2set" 
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    /> */}

     <iframe
   className="w-full h-[177px] lg:h-[300px] lg:w-[579px] md:w-[360px] md:h-[250px] rounded-[10px]"
      src={props?.mapSrc.toString()}
      
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
   
 {/* <GoogleMap
  onLoad={onLoad}
  onUnmount={onUnmount}
 zoom={10} center={center} mapContainerClassName="w-full h-[177px] lg:h-[344px] lg:w-[679px] md:w-[360px] md:h-[250px] rounded-[10px]">
   <Marker position={center} />
 </GoogleMap> */}
 </div>
}


</div>

      </div>
      {/* section */}
      <div className='w-full flex justify-center'>
      <div className='h-[1px] w-[100%] bg-white md:mb-4 lg:mb-[24px] opacity-[32%]'>

      </div>

      </div>
      {/* last */}
     <div className='flex items-center justify-center p-[6vw] md:p-0 lg:p-0 lg:mb-0 md:-mb-10   '>
      <div className='flex items-center flex-col gap-2 md:flex-row lg:flex-row md:flex-wrap justify-between md:w-[90%] lg:w-[98%] '>
      <div>
   <p className={` ${isView?'translation-all duration-500 scale-500':'scale-0'} md:text-[14px]  lg:mb-[27px] lg:text-[23px] lg:leading-[22px] Popp-400 Poppins `}>
   © Copyright 2023, All Rights Reserved 
    </p>   
      </div>
      {/* social middea */}
      <div className={` lg:mb-[18px] ${isView?'translate-x-0 duration-700 p-[12px] ':'translate-full'} p-[12px] lg:p-0 `}>
      <div className='flex gap-5'>
        {/* youtube */}
     {props.social?.youtubeLink&& <a target='_blank' href={checkAndAddHttps(props.social?.youtubeLink)}>

      <svg className='hover:bg-[#6B1768] rounded-full bg-[#1E293B]'  width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">

<g clipPath="url(#clip0_538_2835)">
<path d="M25.0582 12.5885C24.9548 12.2049 24.7527 11.8551 24.4721 11.5738C24.1916 11.2926 23.8422 11.0898 23.4589 10.9855C22.0374 10.5952 16.3509 10.5889 16.3509 10.5889C16.3509 10.5889 10.6652 10.5825 9.24292 10.9556C8.85982 11.0646 8.51118 11.2703 8.23047 11.5529C7.94977 11.8356 7.74643 12.1856 7.63997 12.5694C7.26511 13.9908 7.26148 16.9389 7.26148 16.9389C7.26148 16.9389 7.25785 19.9016 7.62999 21.3085C7.83875 22.0863 8.45143 22.7008 9.23021 22.9105C10.6661 23.3008 16.3373 23.3072 16.3373 23.3072C16.3373 23.3072 22.0238 23.3135 23.4452 22.9414C23.8287 22.8373 24.1784 22.6349 24.4597 22.3543C24.741 22.0736 24.9442 21.7244 25.0491 21.3411C25.4249 19.9206 25.4276 16.9734 25.4276 16.9734C25.4276 16.9734 25.4457 14.0099 25.0582 12.5885ZM14.5319 19.6701L14.5365 14.2241L19.2627 16.9516L14.5319 19.6701Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_538_2835">
<rect width="21.7841" height="21.7841" fill="white" transform="translate(7.26147 6.05078)"/>
</clipPath>
</defs>
</svg>
       </a>
}
{/* telegram */}
{props.social?.telegramLink&&
<a target='_blank' href={checkAndAddHttps(props.social?.telegramLink)}>
<svg className='hover:bg-[#6B1768] rounded-full bg-[#1E293B]'  width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">

<g clipPath="url(#clip0_538_2839)">
<path d="M23.2674 11.0955L10.7506 15.9222C9.8964 16.2653 9.90134 16.7418 10.5939 16.9543L13.8075 17.9568L21.2427 13.2656C21.5943 13.0517 21.9155 13.1668 21.6514 13.4012L15.6274 18.8378H15.626L15.6274 18.8385L15.4058 22.1509C15.7305 22.1509 15.8738 22.002 16.056 21.8262L17.6168 20.3084L20.8636 22.7065C21.4622 23.0362 21.8922 22.8668 22.0411 22.1523L24.1724 12.1079C24.3906 11.2332 23.8385 10.8371 23.2674 11.0955Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_538_2839">
<rect width="16.9432" height="16.9432" fill="white" transform="translate(7.67041 8.47168)"/>
</clipPath>
</defs>
</svg>

</a>
}
{/* facebook */}
{props.social?.facebookLink&&
<a target='_blank' href={checkAndAddHttps(props.social?.facebookLink)}>
<svg className='hover:bg-[#6B1768] rounded-full bg-[#1E293B]' width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M16.1983 24.5733V17.8522H13.9365V15.2329H16.1983V13.3012C16.1983 11.0595 17.5674 9.83887 19.5672 9.83887C20.5251 9.83887 21.3484 9.91019 21.5883 9.94206V12.2848L20.2014 12.2854C19.1138 12.2854 18.9032 12.8022 18.9032 13.5606V15.2329H21.497L21.1592 17.8522H18.9032V24.5733H16.1983Z" fill="white"/>
</svg>

</a>
}
{/* penterst */}
{props.social?.instagramLink&&
<a target='_blank' href={checkAndAddHttps(props.social?.instagramLink)}>

<svg className='hover:bg-[#6B1768] rounded-full bg-[#1E293B]'  width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M17.1712 10.2214C19.3602 10.2214 19.6194 10.2296 20.4841 10.269C21.004 10.2754 21.519 10.3709 22.0067 10.5513C22.3603 10.6877 22.6815 10.8966 22.9495 11.1646C23.2175 11.4326 23.4264 11.7538 23.5628 12.1074C23.7432 12.595 23.8387 13.11 23.845 13.6299C23.8841 14.4947 23.8927 14.7539 23.8927 16.9428C23.8927 19.1318 23.8845 19.391 23.845 20.2557C23.8387 20.7757 23.7432 21.2906 23.5628 21.7783C23.4264 22.1319 23.2175 22.4531 22.9495 22.7211C22.6815 22.9891 22.3603 23.198 22.0067 23.3344C21.519 23.5148 21.004 23.6103 20.4841 23.6167C19.6198 23.6557 19.3606 23.6643 17.1712 23.6643C14.9819 23.6643 14.7227 23.6561 13.8583 23.6167C13.3384 23.6103 12.8234 23.5148 12.3358 23.3344C11.9821 23.198 11.661 22.9891 11.393 22.7211C11.125 22.4531 10.916 22.1319 10.7797 21.7783C10.5992 21.2906 10.5038 20.7757 10.4974 20.2557C10.4584 19.391 10.4498 19.1318 10.4498 16.9428C10.4498 14.7539 10.458 14.4947 10.4974 13.6299C10.5038 13.11 10.5992 12.595 10.7797 12.1074C10.916 11.7538 11.125 11.4326 11.393 11.1646C11.661 10.8966 11.9821 10.6877 12.3358 10.5513C12.8234 10.3709 13.3384 10.2754 13.8583 10.269C14.723 10.23 14.9823 10.2214 17.1712 10.2214ZM17.1712 8.74414C14.946 8.74414 14.6657 8.75351 13.7912 8.79333C13.1107 8.80686 12.4375 8.9357 11.8001 9.17436C11.2534 9.38036 10.7582 9.70317 10.349 10.1203C9.93156 10.5296 9.60846 11.0251 9.40234 11.5722C9.16368 12.2095 9.03484 12.8827 9.02131 13.5632C8.98227 14.4369 8.9729 14.7172 8.9729 16.9425C8.9729 19.1677 8.98227 19.448 9.02209 20.3225C9.03562 21.0029 9.16446 21.6762 9.40312 22.3135C9.60901 22.8605 9.93184 23.356 10.349 23.7654C10.7584 24.1826 11.2539 24.5054 11.8009 24.7113C12.4383 24.95 13.1115 25.0788 13.7919 25.0924C14.6664 25.1314 14.9456 25.1415 17.172 25.1415C19.3984 25.1415 19.6776 25.1322 20.552 25.0924C21.2325 25.0788 21.9057 24.95 22.5431 24.7113C23.0875 24.5003 23.5819 24.178 23.9946 23.7649C24.4074 23.3519 24.7294 22.8573 24.9401 22.3127C25.1787 21.6754 25.3076 21.0022 25.3211 20.3217C25.3602 19.448 25.3695 19.1677 25.3695 16.9425C25.3695 14.7172 25.3602 14.4369 25.3203 13.5624C25.3068 12.882 25.178 12.2087 24.9393 11.5714C24.7334 11.0244 24.4106 10.5289 23.9934 10.1195C23.584 9.7023 23.0885 9.37947 22.5415 9.17358C21.9041 8.93492 21.2309 8.80608 20.5505 8.79255C19.6768 8.75351 19.3965 8.74414 17.1712 8.74414Z" fill="white"/>
<path d="M17.1729 12.7334C16.3403 12.7334 15.5263 12.9803 14.834 13.4429C14.1416 13.9055 13.602 14.563 13.2834 15.3323C12.9647 16.1016 12.8813 16.9481 13.0438 17.7648C13.2062 18.5814 13.6072 19.3316 14.196 19.9204C14.7848 20.5092 15.5349 20.9101 16.3516 21.0726C17.1683 21.235 18.0147 21.1516 18.784 20.833C19.5533 20.5143 20.2108 19.9747 20.6734 19.2824C21.136 18.5901 21.383 17.7761 21.383 16.9434C21.383 15.8269 20.9394 14.756 20.1499 13.9665C19.3603 13.177 18.2895 12.7334 17.1729 12.7334ZM17.1729 19.6762C16.6324 19.6762 16.1041 19.5159 15.6547 19.2156C15.2053 18.9154 14.855 18.4886 14.6482 17.9892C14.4413 17.4899 14.3872 16.9404 14.4927 16.4103C14.5981 15.8802 14.8584 15.3933 15.2406 15.0111C15.6227 14.6289 16.1097 14.3686 16.6398 14.2632C17.1699 14.1577 17.7194 14.2118 18.2187 14.4187C18.7181 14.6255 19.1449 14.9758 19.4451 15.4252C19.7454 15.8746 19.9057 16.4029 19.9057 16.9434C19.9057 17.6682 19.6178 18.3633 19.1053 18.8758C18.5928 19.3883 17.8977 19.6762 17.1729 19.6762Z" fill="white"/>
<path d="M21.5485 13.5506C22.0918 13.5506 22.5323 13.1101 22.5323 12.5668C22.5323 12.0235 22.0918 11.583 21.5485 11.583C21.0052 11.583 20.5647 12.0235 20.5647 12.5668C20.5647 13.1101 21.0052 13.5506 21.5485 13.5506Z" fill="white"/>
</svg>
</a>
}
{/* tiktok */}
{props.social?.tiktokLink&&
<a target='_blank' href={checkAndAddHttps(props.social?.tiktokLink)}>

<svg className='hover:bg-[#6B1768] rounded-full bg-[#1E293B]'  width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">

<g clipPath="url(#clip0_538_2855)">
<path fillRule="evenodd" clipRule="evenodd" d="M19.6974 7.56348C19.9381 7.56348 20.169 7.65911 20.3392 7.82933C20.5094 7.99955 20.605 8.23042 20.605 8.47115C20.6055 9.30795 20.8948 10.1189 21.424 10.7672C21.9532 11.4154 22.6898 11.8612 23.5096 12.0292C23.7455 12.0774 23.9526 12.2173 24.0854 12.4181C24.2182 12.619 24.2657 12.8644 24.2176 13.1003C24.1694 13.3362 24.0295 13.5433 23.8287 13.6761C23.6278 13.8089 23.3824 13.8564 23.1465 13.8082C22.2007 13.615 21.3235 13.1732 20.605 12.5284V20.2709C20.605 21.1685 20.3389 22.0459 19.8402 22.7922C19.3415 23.5386 18.6327 24.1203 17.8034 24.4638C16.9742 24.8072 16.0616 24.8971 15.1813 24.722C14.3009 24.5469 13.4923 24.1147 12.8576 23.48C12.2229 22.8453 11.7906 22.0366 11.6155 21.1563C11.4404 20.2759 11.5303 19.3634 11.8738 18.5341C12.2173 17.7048 12.799 16.996 13.5453 16.4974C14.2916 15.9987 15.1691 15.7325 16.0667 15.7325C16.3074 15.7325 16.5383 15.8281 16.7085 15.9984C16.8787 16.1686 16.9743 16.3995 16.9743 16.6402C16.9743 16.8809 16.8787 17.1118 16.7085 17.282C16.5383 17.4522 16.3074 17.5479 16.0667 17.5479C15.5281 17.5479 15.0016 17.7076 14.5539 18.0068C14.1061 18.306 13.757 18.7312 13.5509 19.2288C13.3448 19.7264 13.2909 20.2739 13.396 20.8021C13.5011 21.3303 13.7604 21.8155 14.1412 22.1963C14.522 22.5771 15.0072 22.8365 15.5354 22.9416C16.0637 23.0466 16.6112 22.9927 17.1087 22.7866C17.6063 22.5805 18.0316 22.2315 18.3308 21.7837C18.63 21.3359 18.7897 20.8094 18.7897 20.2709V8.47115C18.7897 8.23042 18.8853 7.99955 19.0555 7.82933C19.2258 7.65911 19.4566 7.56348 19.6974 7.56348Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_538_2855">
<rect width="21.7841" height="21.7841" fill="white" transform="translate(5.47729 4.84082)"/>
</clipPath>
</defs>
</svg>
</a>
}
        </div>  
      </div>

      </div>
      </div> 
    </div>
  </div>
  )
}

export default Footer

